import type { Course, CourseContainers } from '@yandex-int/k-common';
import { withHookProps } from 'platform-components';
import { useSelector } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { getLessonsCounts } from 'store/courses/selectors';

import { QueryConfig } from 'react-query';
import { useCourseContainersQuery } from './queries';

export function useCourseContainers(courseId?: number, queryConfig?: QueryConfig<CourseContainers>) {
    const defaultCourseId = useSelector(getCurrentYearCourseId);

    const courseContainerCourseId = courseId || defaultCourseId;
    const lessonsCounts = useSelector((storeState) =>
        getLessonsCounts(storeState, { courseId: courseContainerCourseId })
    );
    return useCourseContainersQuery(courseContainerCourseId, lessonsCounts, queryConfig);
}

export function useCourseContainerProps(props?: { course?: Course }) {
    const courseContainersQuery = useCourseContainers();
    const lastContainerSlug = props?.course?.last_container;
    let courseContainer = lastContainerSlug
        ? courseContainersQuery.data?.find((cc) => cc.container.slug === lastContainerSlug)
        : undefined;
    courseContainer = courseContainer || courseContainersQuery.data?.[0];

    return {
        courseContainer,
        isCourseContainerSuccess: courseContainersQuery.isSuccess,
        isCourseContainerFetchingOrLoading: courseContainersQuery.isLoading || courseContainersQuery.isFetching,
    };
}

export type CourseContainerProps = ReturnType<typeof useCourseContainerProps>;

export const withCourseContainer = withHookProps(useCourseContainerProps);
